import {styled} from '@mui/material/styles';

export const Title = styled('h3')({
  textAlign: 'center',
  color: '#1e98d9',
});

export const Content = styled('p')({
  textAlign: 'center',
});
